






































import Sign from '@/servers/modules/signinsignup';
import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import NProgress from 'nprogress';
import MyNav from '@/components/skeleton/top.vue'; // 骨架结构顶部
import {
  Button, Message, Scrollbar, Form, FormItem, Input, Select, Option, DatePicker, Radio,
} from 'element-ui';
import Person from '@/servers/modules/person';
// server
    @Component({
      components: {
        MyNav,
        Button,
        Scrollbar,
        Form,
        FormItem,
        Input,
        Select,
        Option,
        DatePicker,
        Radio,
      },
    })
export default class extends Vue {
        private courseTitle : string = window.LS.get('basicData').courseName;

        private mainListOrder : any = 1;
        // 词性：1、派生词 2、同义词 3、近义词 4、反义词 5、易混 6、复合词 7、类属8、常用搭配 9、变形词 11、回 文词 12、拟声 13、辨析词 14、助记语 15、词根相同 16、词缀相同

        private isChoseIndex:any={
          scourceIndex: undefined,
          targetIndex: undefined,
        };

        private myScource:any = [
          { name: '派生词', id: 1 },
          { name: '同义词', id: 2 },
          { name: '近义词', id: 3 },
          { name: '反义词', id: 4 },
          { name: '易混', id: 5 },
          { name: '复合词', id: 6 },
          { name: '类属', id: 7 },
          { name: '常用搭配', id: 8 },
          { name: '变形词', id: 9 },
          { name: '回 文词', id: 11 },
          { name: '拟声', id: 12 },
          { name: '辨析词', id: 13 },
          { name: '助记语', id: 14 },
          { name: '词根相同', id: 15 },
          { name: '词缀相同', id: 16 },
        ];

        private myTarget:any = [];

        @Getter public navData: any;

        @Getter public skeleton: any;

        @Mutation public setSkeletonDescribe;

        @Mutation public openDialog;

        @Mutation public closeDialog;

        private created() {
          // 初始化内容信息
          const studentCourse = window.LS.get('vteData');

          this.mainListOrder = studentCourse.mainListOrder || 1;
          if (studentCourse.secondListOrder != '' && studentCourse.secondListOrder) {
            alert('1');
            // 解析已经设置的内容
            const secondListOrder = studentCourse.secondListOrder.split(',');
            this.myTarget = [];
            for (let j = 0; j < secondListOrder.length; j++) {
              for (let i = 0; i < this.myScource.length; i++) {
                if (this.myScource[i].id == secondListOrder[j]) {
                  this.myTarget.push(this.myScource[i]);
                  // 删除原有数组内的内容
                  this.myScource.splice(i, 1);
                }
              }
            }
          }
        }

        // 添加词关系
        private addAndRemove() {
          if (this.isChoseIndex.scourceIndex != undefined) {
            this.myTarget.push(this.myScource[this.isChoseIndex.scourceIndex]);
            this.myScource.splice(this.isChoseIndex.scourceIndex, 1);
            if (this.isChoseIndex.scourceIndex >= this.myScource.length) {
              this.isChoseIndex.scourceIndex = undefined;
            }
          }
        }

        // 删除词关系
        private removeAndAdd(index:number = null) {
          this.myScource.push(this.myTarget[index]);
          this.myTarget.splice(index, 1);
          // if (this.isChoseIndex.targetIndex != undefined) {
          //   this.myScource.push(this.myTarget[index || this.isChoseIndex.targetIndex]);
          //   this.myTarget.splice(index || this.isChoseIndex.targetIndex, 1);
          //   if (this.isChoseIndex.targetIndex >= this.myTarget.length) {
          //     this.isChoseIndex.targetIndex = undefined;
          //   }
          // }
        }

        // 设置
        private setIndex(index, itemIndex) {
          this.isChoseIndex[itemIndex] = index;
        }

        // 上移 下移
        private moveIndex(type) {
          if (this.isChoseIndex.targetIndex != undefined) {
            // 完整保存当前节点;
            const nowIndex = this.isChoseIndex.targetIndex;
            let nextIndex = 0;
            if (type == 'up') {
              nextIndex = nowIndex - 1;
            } else if (type == 'down') {
              nextIndex = nowIndex + 1;
            }
            if (nextIndex > this.myTarget.length - 1 || nextIndex < 0) {
              return false;
            }
            // 保存几点内容
            const nextContent = this.myTarget[nextIndex];
            const nowContent = this.myTarget[nowIndex];
            this.myTarget.splice(nextIndex, 1, nowContent);
            this.myTarget.splice(nowIndex, 1, nextContent);
            // 赋值但前节点为下一个节点
            this.isChoseIndex.targetIndex = nextIndex;
          }
        }

        // 是否被选中
        private isChose(index, itemIndex) {
          if (this.isChoseIndex[itemIndex] == index) {
            return 'chose';
          }
          return '';
        }

        private isChoseActive(index, itemIndex) {
          if (this.isChoseIndex[itemIndex] == index) {
            return 'chose-active';
          }
          return '';
        }

        // 保存设置
        private async saveSet() {

          const secondListOrderStr:any = [];
          for (let i = 0; i < this.myTarget.length; i++) {
            secondListOrderStr.push(this.myTarget[i].id);
          }
          const form :any = {
            courseId: Number(window.LS.get('basicData').courseId),
            mainListOrder: this.mainListOrder,
            secondListOrderStr: secondListOrderStr.join(','),
            userCourseId: window.LS.get('vteData').userCourseId,
            userId: window.LS.get('basicData').userID,
          };
          const res = await Person.personConfig(form).finally((e) => {

          });
          if (!res.data.code) {
            // 手动更新本地存储
            // const vteData = window.LS.get('vteData');
            // const { studentCourse } = window.LS.get('vteData');
            // studentCourse.mainListOrder = form.mainListOrder;
            // studentCourse.secondListOrder = secondListOrderStr.join(',');
            // vteData.studentCourse = studentCourse;
            // window.LS.set('vteData', vteData);
            Message.success(res.data.data);
          }
        }
}
